module.exports = __webpack_public_path__ + "img/pie-plug.35baa20c.svg";